import { Combobox, type ComboboxOption } from "./combobox";

export type SelectOption = ComboboxOption;

type Props = {
  options: SelectOption[];
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  /** Form name — renders a hidden input so this plugs into a `<form>`,
   *  same as `Combobox`. */
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  size?: "default" | "sm";
  "aria-label"?: string;
  "data-testid"?: string;
};

/**
 * Drop-in replacement for a native `<select>` with a fixed, short
 * option list (status / priority / type / scope / team slot / …) —
 * a non-searchable `Combobox`. See `Combobox`'s `searchable` prop for
 * why native `<select>` was retired app-wide: a styled one now opens
 * as a press-drag-release menu in Chrome, so a plain click commits
 * whatever option the cursor happens to land on instead of just
 * opening the list.
 *
 * Callers that used to render `<option value="">All statuses</option>`
 * as the first native option keep doing exactly that here — pass it
 * as a normal entry in `options`, not as `placeholder` (`placeholder`
 * is only the fallback text shown when `value` matches no option at
 * all, e.g. before data loads).
 */
export function Select(props: Props) {
  return <Combobox {...props} searchable={false} />;
}
